const WindowWrapper = {
  setLocation(url) {
    window.location.href = url;
  },

  getLocation() {
    return window.location;
  }
};

export default WindowWrapper;
